<template>
    <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <!--ヘッダーにmax-width1920がいらない時はここを削除。対応する</div>も一緒に-->
      <div class="m-width1920">
        <div class="d-flex align-items-center">
          <!--ここまで↑-->
          <a class="navbar-brand" href="/">
            <img
              class="navbar-logo"
              src="@/assets/img/logo/treasure_logo.png"
              alt="野球グラブのオーダーメイドシミュレーション | Treasure ロゴ"
            />
          </a>
          <div class="nav-link">
            TOP > お問い合わせ > お問い合わせ内容の確認
          </div>
        </div>
      </div>
    </nav>

    <div class="container mt-5 confirmation-main form-main">
        <div class="card form-card">
          <div class="card-body">
            <p class="text-center text-color-fff lead form-text-center">お問い合わせ内容の確認</p>

            <table class="delivery-info">
              <tbody>
                <tr>
                  <th>お名前:</th>
                  <td>{{ formData.name }}</td>
                </tr>
                <tr>
                  <th>お名前（かな）:</th>
                  <td>{{ formData.nameKana }}</td>
                </tr>
                <tr>
                  <th>メールアドレス:</th>
                  <td>{{ formData.email }}</td>
                </tr>
                <tr>
                  <th>お問い合わせ内容:</th>
                  <td>{{ formData.message }}</td>
                </tr>
              </tbody>
            </table>

            <div class="form-row form__btn_gap">
              <div class="col">
                <button
                @click="goBack"
                  class="form-btn-block form-btn-secondary btn btn-block"
                >
                  修正する
                </button>
              </div>
              <div class="col">
                <button
                  type="button"
                  class="form-btn-block form-btn-secondary btn btn-block"
                  :disabled="sending"
                  @click="goSubmit"
                >
                  {{ sending ? "送信中..." : "送信する" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
  import { sendMail, MAIL_TYPES } from "../utils/mailer";

  export default {
    name: "InquiryConfirmation",
    data() {
    return {
      formData: {
        name: "",
        nameKana: "",
        email: "",
        message: "",
      },
      sending: false,
    };
  },
    created() {
      this.formData.name = sessionStorage.getItem("name") || "";
      this.formData.nameKana = sessionStorage.getItem("nameKana") || "";
      this.formData.email = sessionStorage.getItem("email") || "";
      this.formData.message = sessionStorage.getItem("message") || "";
    },

    methods: {
      async goSubmit() {
        this.sending = true;
        try {
          const templateParams = {
            name: this.formData.name,
            name_kana: this.formData.nameKana,
            email: this.formData.email,
            message: this.formData.message,
          };
          // お客様への自動返信と運営への通知の両方を送信する
          await Promise.all([
            sendMail(MAIL_TYPES.INQUIRY_CUSTOMER, templateParams),
            sendMail(MAIL_TYPES.INQUIRY_ADMIN, templateParams),
          ]);
          this.$router.push({ name: "ContactThanksPage" });
        } catch (error) {
          console.error("[InquiryConfirmation] メール送信に失敗しました", error);
          alert("送信に失敗しました。時間をおいて再度お試しください。");
        } finally {
          this.sending = false;
        }
      },
      goBack() {
        // 入力画面に戻る
        this.$router.back();
      },
    },
  };
</script>

<style scoped>
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form__btn_gap {
  gap: 5vw;
  padding: 1vw 0 3vw 0;
}
.col {
  padding-right: 5px;
  padding-left: 5px;
}

.form-btn-block {
  padding: 10px;
  font-size: 16px;
  border-radius: 25px;
}
.btn-block {
  display: block;
  width: 100%;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.form-main {
  max-width: 700px;
}

/* テーブルスタイル */
.delivery-info {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
}

/* 左側（ラベル）のスタイル */
.delivery-info th {
  text-align: left;
  font-weight: bold;
  padding: 8px 0px 4px 12%;
  white-space: nowrap; /* テキストの折り返しを防ぐ */
  color: #fff; /* ラベルの色（必要に応じて変更） */
  vertical-align: top;
}

/* 右側（データ）のスタイル */
.delivery-info td {
  padding: 8px 0px 4px 12%;
  color: #fff; /* データの色（必要に応じて変更） */
  overflow-wrap: anywhere;
}

/* カードのスタイル */
.card {
  background-color: transparent; /* 背景を透過に */
  border: none; /* カード枠を消す */
  margin: 0;
  padding: 0;
}

table {
  width: 100%; /* 親要素いっぱいに広げる */
  border-collapse: collapse; /* セル間の隙間をなくす */
}

p {
  margin-top: 1rem;
  margin-bottom: 0rem;
}

li {
  list-style: none;
}

@media (max-width: 500px) {
  li {
    font-size: 3vw;
  }
}

@media (max-width: 400px) {
  li {
    font-size: 2.4vw;
  }
  .col {
    padding-left: 2px;
    padding-right: 2px;
  }
}

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  background-color: #000 !important; /* 背景色を黒 */
  -webkit-text-fill-color: #fff !important; /* テキスト色を白 */
  box-shadow: 0 0 0px 1000px #000 inset !important; /* 背景を完全に黒で塗りつぶす */
}

/* Firefox用 */
input:-moz-autofill,
textarea:-moz-autofill,
select:-moz-autofill {
  background-color: #000 !important; /* 背景色を黒 */
  color: #fff !important; /* テキスト色を白 */
}

/* :active時の色変更を防ぐ */
.form-btn-block:active {
  background-color: #fff; /* 背景色を維持 */
  color: #000; /* テキスト色を維持 */
}

/* :focus-visible時の色変更を防ぐ */
.form-btn-block:focus-visible {
  background-color: #fff; /* 背景色を維持 */
  color: #000; /* テキスト色を維持 */
}

.navbar {
  padding: 8px 10px;
}

.form__btn_gap {
  gap: 1vw;
  padding: 48px 0 0 0;
}

.form-card {
  margin: 0 auto;
  max-width: 500px;
  border: 1px solid #000;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.text-color-fff {
  padding-bottom: 40px;
}
</style>